import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import Loading from "../ui/Loading.js";
import "moment/min/locales";
import "xlsx/dist/xlsx.full.min.js";
import { FormattedMessage, injectIntl } from "react-intl";
import { makeStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import Backdrop from "@material-ui/core/Backdrop";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import * as Utils from '../../commons/utils/Utils';
import swal from 'sweetalert'
import Fade from "@material-ui/core/Fade";
import {Grid} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import PresupuestoDetalladoItemGrid from "./PresupuestoDetalladoItemGrid";
import CostoFijoTooltip from "./CostoFijoTooltip";
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import { TextFieldWithCounter, limitMontoDigits } from '../ui/commons/inputs';
import { formatCost } from '../../commons/utils/Helpers';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
};

const requiredSymbol = ' *';

const NEW_ITEM_INIT = {
	external_code: '',
	descripcion: '',
	clasificacion: '',
	id_clasificacion: null,
	detalle: '',
	cuenta_mayor: '',
	cuenta_mayor_descripcion: '',
	cantidad: '',
	costo: '',
	id_item: null,
	servicio_id: null,
	servicio: '',
	marcaNombre: '',
	id: null,
	marca: null,
	categoria: null
};

const PresupuestoDetalladoItem = (props) => {
	const intl = props.intl;
	const [loading, setLoading] = useState(false);
	const [redirectTo, setRedirectTo] = useState(null);
	const [newPresupuestoItem, setNewPresupuestoItem] = useState({ ...NEW_ITEM_INIT })
	const [items, setItems] = useState([]);
	const [servicios, setServicios] = useState([]);
	const [presupuestoItems, setPresupuestoItems] = useState([]);
	const [comboInsumoMarca, setComboInsumoMarca] = useState([]);
	const [clasificaciones, setClasificaciones]   = useState([]);
	const [marcaObligatorio, setMarcaObligatorio] = useState(false);
	const MySwal = withReactContent(Swal);
	const [busquedaPor, setBusquedaPor] = useState(() => {
		const nombreIndex = props.showItems.indexOf('descripcion');
		const servicioIndex = props.showItems.indexOf('servicio');
		if (servicioIndex !== -1 && nombreIndex !== -1 && servicioIndex < nombreIndex) {
			return 'servicio';
		}
		return 'descripcion';
	});
	const [servicioObligatorio, setServicioObligatorio] = useState(ConfigBusiness.get('servicios.repuestos.habilitado') === 'true' ? true : false);
	const [mecanicos, setMecanicos] = useState([]);

	useEffect(() => {
	  	init();
  	}, []);

	useEffect(() => {
		setPresupuestoItems(props.presupuestoItems);
	}, [props.presupuestoItems]);

	const init = () => {
		loadInit(null);
		if(props.showItems && props.showItems.includes('clasificacion')){
			getClasificaciones();
		}
		if(props.showItems && props.showItems.includes('mecanico')){
			loadMecanicos();
		}
	}

	const loadMecanicos = () => {
		var tallerId = props.ticket ? props.ticket.taller.id : null;
		if(!tallerId){ return; }
		Utils.getData('/usuarios/mecanicos-por-taller/' + tallerId)
		.then(function(data) {
			setMecanicos(data.map(function(m) {
				return Object.assign({}, m, { nombreCompleto: m.nombre + ' ' + m.apellido });
			}));
		});
	}

	const renderField = (field) => {
		switch (field) {
			case 'id':
				return (
					<Grid component={Box} item xs={2} key="id">
						<form noValidate autoComplete="off">
							<Autocomplete
								clearText="Clear"
								type="number"
								id="id"
								name="id"
								options={items}
								value={newPresupuestoItem}
								getOptionLabel={(option) => option.id ? option.id.toString() : ''}
								onChange={(event, value) => handleFormChangeSelectObject(value)}
								renderInput={(params) => (
									<TextField {...params}
										type="number"
										label={intl.formatMessage({ id: "Presupuesto.Id", defaultMessage: "Id" })}
										placeholder={intl.formatMessage({id: 'Presupuesto.Id', defaultMessage: 'Id'})}
										onChange={handleInputChange}
									/>
								)}
							/>
						</form>
					</Grid>
				);
			case 'external_code':
				return (
					<Grid component={Box} item xs={2} key="external_code">
						<form noValidate autoComplete="off">
							<TextField
								id="external_code"
								InputLabelProps={newPresupuestoItem.external_code ? { shrink: true} : {}}
								label={intl.formatMessage({ id: 'Presupuesto.Repuesto', defaultMessage: 'Repuesto' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Repuesto', defaultMessage: 'Repuesto' })}
								value={newPresupuestoItem.external_code}
								onChange={e => handleMaterialChange('external_code', e.target.value)}
								onBlur={HandleURepuesto}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'descripcion':
				return (
					<Grid component={Box} item xs={2} key="descripcion">
						<form noValidate autoComplete="off">
							<Autocomplete
								disabled={servicioObligatorio ? (busquedaPor === 'descripcion' ? false : (!newPresupuestoItem.servicio ? true : false)) : false}
								id="descripcion"
								name="descripcion"
								options={items}
								value={newPresupuestoItem}
								getOptionLabel={(option) => option.descripcion ? option.descripcion : ''}
								onChange={(event, value) => handleFormChangeSelectObject(value)}
								onBlur={(e) => resetSelect(newPresupuestoItem, 'descripcion')}
								renderInput={(params) => (
									<TextField {...params}
										label={intl.formatMessage({ id: "Presupuesto.Descripción", defaultMessage: "Descripción" })}
										placeholder={intl.formatMessage({id: 'Presupuesto.Descripción', defaultMessage: 'Descripción'})}
										onChange={handleInputChange}
									/>
								)}
							/>
						</form>
          			</Grid>
				);
			case 'clasificacion':
				return (
					<Grid component={Box} item xs={2} key="clasificacion">
						<form noValidate autoComplete="off">
							<Autocomplete
								id="clasificacion"
								name="clasificacion"
								options={clasificaciones}
								value={clasificaciones.find(c => c.nombre === newPresupuestoItem.clasificacion) || null}
								getOptionLabel={(option) => option.nombre ? option.nombre : ''}
								onChange={(event, value) => {
									let copy = JSON.parse(JSON.stringify(newPresupuestoItem));
									if(value){
										copy.clasificacion = value.nombre;
										copy.id_clasificacion = value.id;
									}else{
										copy.clasificacion = '';
										copy.id_clasificacion = null;
									}
									setNewPresupuestoItem(copy);
								}}
								renderInput={(params) => (
									<TextField {...params}
										label={intl.formatMessage({ id: "Presupuesto.Clasificación", defaultMessage: "Clasificación" })}
										placeholder={intl.formatMessage({id: 'Presupuesto.Clasificación', defaultMessage: 'Clasificación'})}
									/>
								)}
							/>
						</form>
					  </Grid>
				);
		case 'detalle':
			return (
				<Grid component={Box} item xs={2} key="detalle">
					<form noValidate autoComplete="off">
						<TextFieldWithCounter
							id="detalle"
							maxLength={60}
							label={intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
							placeholder={intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
							value={newPresupuestoItem.detalle}
							onChange={e => handleMaterialChange('detalle', e.target.value)}
							className="col-12"
						/>
					</form>
				</Grid>
			);
			case 'cuenta_mayor_descripcion':
				return (
					<Grid component={Box} item xs={2} key="cuenta_mayor_descripcion">
						<form noValidate autoComplete="off">
							<TextField
								disabled={true}
								id="cuenta_mayor_descripcion"
								type="text"
								InputLabelProps={newPresupuestoItem.cuenta_mayor_descripcion ? { shrink: true} : {}}
								label={intl.formatMessage({ id: 'Presupuesto.descrip._Cuenta_Mayor', defaultMessage: 'Descrip. Cuenta Mayor' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.descrip._Cuenta_Mayor', defaultMessage: 'Descrip. Cuenta Mayor' })}
								value={newPresupuestoItem.cuenta_mayor_descripcion}
								onChange={e => handleMaterialChange('cuenta_mayor_descripcion', e.target.value)}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'cantidad':
				return (
					<Grid component={Box} item xs={1} key="cantidad">
						<form noValidate autoComplete="off">
							<TextField
								id="cantidad"
								type="number"
								InputLabelProps={newPresupuestoItem.cantidad ? { shrink: true} : {}}
								InputProps={{
									inputProps: { min: 0 }
								}}
								label={intl.formatMessage({ id: 'Presupuesto.Cantidad', defaultMessage: 'Cantidad' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Cantidad', defaultMessage: 'Cantidad' })}
								value={newPresupuestoItem.cantidad}
								onChange={e => handleMaterialChange('cantidad', e.target.value)}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'costo':
				return (
					<Grid component={Box} item xs={2} key="costo">
						<form noValidate autoComplete="off">
							<TextField
								disabled={newPresupuestoItem.costo_fijo === 1}
								id="costo"
								type="number"
								InputLabelProps={newPresupuestoItem.costo ? { shrink: true} : {}}
								InputProps={{
									inputProps: { min: 0 }
								}}
								label={
									<span style={{ display: 'inline-flex', alignItems: 'center' }}>
										{intl.formatMessage({ id: 'Presupuesto.Precio', defaultMessage: 'Precio' })}
										<CostoFijoTooltip
											costoFijo={newPresupuestoItem.costo_fijo === 1}
											descripcion={'"'.concat(newPresupuestoItem.descripcion).concat('"')}
										/>
									</span>
								}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Precio', defaultMessage: 'Precio' })}
								value={newPresupuestoItem.costo}
								onChange={e => handleMaterialChange('costo', e.target.value)}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'marcaNombre':
				return (
					<Grid component={Box} item xs={2} key="marcaNombre">
						<form noValidate autoComplete="off">
							<TextField
								disabled={true}
								id="marcaNombre"
								type="text"
								InputLabelProps={newPresupuestoItem.marcaNombre ? { shrink: true} : {}}
								InputProps={{
									inputProps: { min: 0 }
								}}
								label={intl.formatMessage({ id: 'Presupuesto.Marca', defaultMessage: 'Marca' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Marca', defaultMessage: 'Marca' })}
								value={newPresupuestoItem.marcaNombre}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'marca':
				return !marcaObligatorio ? (
					<Grid component={Box} item xs={2} key="marca">
						<form noValidate autoComplete="off">
							<Autocomplete
								id="marca"
								name="marca"
								options={comboInsumoMarca}
								value={newPresupuestoItem.marca}
								getOptionLabel={(option) => option.nombre ? option.nombre : ''}
								onChange={(event, value) => {
									const itemCopy = JSON.parse(JSON.stringify(newPresupuestoItem));
									setNewPresupuestoItem({...itemCopy, marca: value})
								}}
								renderInput={(params) => (
									<TextField {...params}
										label={intl.formatMessage({ id: "Presupuesto.Marca", defaultMessage: "Marca" })}
										placeholder={intl.formatMessage({id: 'Presupuesto.Marca', defaultMessage: 'Marca'})}
									/>
								)}
							/>
						</form>
					</Grid>) : '';
			case 'servicio':
				return (
					<Grid component={Box} item xs={2} key="servicio">
						<form noValidate autoComplete="off">
							<Autocomplete
								disabled={busquedaPor === 'descripcion' ? (newPresupuestoItem.descripcion ? false : true) : false}
								id="servicio"
								name="servicio"
								options={servicios}
								value={newPresupuestoItem.servicio}
								getOptionLabel={(option) => option.nombre ? option.nombre : ''}
								onChange={(event, value) => busquedaPor === 'servicio' ? handleFormChangeSelectServicio(value) : handleChangeSelectServicio(value)}
								renderInput={(params) => (
									<TextField {...params}
										label={intl.formatMessage({ id: 'Presupuesto.Servicio', defaultMessage: 'Servicio' })}
										placeholder={intl.formatMessage({ id: 'Presupuesto.Servicio', defaultMessage: 'Servicio' })}
									/>
								)}
							/>
						</form>
					</Grid>
				);
			default:
				return null;
		}
	}

	const resetSelect = (item, column) => {
		if(column === 'clasificacion'){
			if(!item.clasificacion){
				getClasificaciones();
			}
		} else {
			if(!item.descripcion){
				loadInit(column);
			}
		}
	};

	const setLoadingAndUpdate = (state) => {
		setLoading(state);
	};

	const handleMaterialChange = (name, value) => {
		let copy = JSON.parse(JSON.stringify(newPresupuestoItem));
		if (name === "costo") {
			const limited = limitMontoDigits(value);
			if ((limited && limited >= 0) || !limited) {
				copy[name] = limited;
			}
		} else if (name === "cantidad") {
			if ((value && value >= 0) || !value) {
				copy[name] = value;
			}
		} else {
			copy[name] = value;
		}
		copy.servicio = newPresupuestoItem.servicio
		setNewPresupuestoItem(copy)
	};

	const HandleURepuesto = (e) => {
		let external_code = e.target.value;
		if (external_code) { validateRepuesto(external_code); }
	};

	const validateRepuesto = (external_code) => {
		Utils.getData('/items/simple-search?external_code=' + external_code)
		.then((data) => {
			if(data.length > 0){
				let copy = JSON.parse(JSON.stringify(newPresupuestoItem));
				copy.external_code = data[0].external_code ? data[0].external_code : ''
				copy.descripcion = data[0].descripcion ? data[0].descripcion : ''
				copy.clasificacion = data[0].clasificacion ? data[0].clasificacion : ''
				copy.id_clasificacion = data[0].id_clasificacion ? data[0].id_clasificacion : null
				copy.detalle = data[0].detalle ? data[0].detalle : ''
				copy.cuenta_mayor = data[0].cuenta_mayor ? data[0].cuenta_mayor : ''
				copy.cuenta_mayor_descripcion = data[0].cuenta_mayor_descripcion ? data[0].cuenta_mayor_descripcion : ''
				copy.costo = data[0].costo ? data[0].costo : "0"
				copy.id_item = data[0].id
				setNewPresupuestoItem(copy)
				loadServices(data[0].id)
			}else{
				swal(
					intl.formatMessage({id: 'El_código_de_repuesto_es_inexistente', defaultMessage: 'El código de repuesto es inexistente.' }),
					intl.formatMessage({id: 'Por_favor_ingrese_los_datos_manualmente.', defaultMessage: 'Por favor ingrese los datos manualmente.' }),
					"warning"
				);
				let copy = JSON.parse(JSON.stringify(newPresupuestoItem));
				copy.external_code = '';
				copy.descripcion = ''
				copy.clasificacion = ''
				copy.id_clasificacion = null
				copy.detalle = ''
				copy.id_item = ''
				copy.cuenta_mayor = ''
				copy.cuenta_mayor_descripcion = ''
				copy.costo = ''
				setServicios([]);
				setNewPresupuestoItem(copy)
			}
		});
	};

	const handleFormChangeSelectObject = (value) => {
		let copy = JSON.parse(JSON.stringify(newPresupuestoItem));
		if(value){
			copy.external_code = value.external_code ? value.external_code : ''
			copy.descripcion = value.descripcion ? value.descripcion : ''
			copy.clasificacion = value.clasificacion ? value.clasificacion : ''
			copy.id_clasificacion = value.id_clasificacion ? value.id_clasificacion : null
			copy.detalle = value.detalle ? value.detalle : ''
			copy.cuenta_mayor = value.cuenta_mayor ? value.cuenta_mayor : ''
			copy.cuenta_mayor_descripcion = value.cuenta_mayor_descripcion ? value.cuenta_mayor_descripcion : ''
			copy.costo = value.costo ? value.costo : "0"
			copy.id_item = value.id
			copy.id = value.id
			copy.marcaNombre = value.marcaNombre
			copy.categoria = value.categoria
			// nuevo: respetar costo_fijo del item seleccionado
			copy.costo_fijo = value.costo_fijo;
			loadServices(value.id)
			if (!marcaObligatorio) getMarcasByCategoria(value.categoria);
		}else{
			copy.id = '';
			copy.descripcion = '';
			copy.clasificacion = '';
			copy.id_clasificacion = null;
			copy.detalle = '';
			copy.id_item = null;
			if(busquedaPor === 'descripcion'){
				copy.servicio = null;
				copy.servicio_id = null;
				copy.cantidad = '';
			}
			copy.costo = '';
			copy.categoria = null;
			copy.marca = null;
			copy.costo_fijo = null;
			setComboInsumoMarca([]);
			loadInit(null);
		}
		setNewPresupuestoItem(copy)
	};

	const handleInputChange = (e) => {
		let value = e.target.value;
		let column = e.target.id;
		if(busquedaPor === 'descripcion'){
			Utils.getData('/items/simple-search?column=' + column + '&value=' + value + (props.tipoItem ? '&tipoItem=' + encodeURIComponent(props.tipoItem) : ''))
			.then((data) => {
				setItems(data)
			});
		}else if(!servicioObligatorio){
			Utils.getData('/items/simple-search?column=' + column + '&value=' + value + (props.tipoItem ? '&tipoItem=' + encodeURIComponent(props.tipoItem) : ''))
			.then((data) => {
				setItems(data)
			});
		}
	};

	const addItem = () => {
		newPresupuestoItem.cantidad = newPresupuestoItem.cantidad ? newPresupuestoItem.cantidad : 1;
		newPresupuestoItem.costo = newPresupuestoItem.costo ? newPresupuestoItem.costo : 0;
		props.addItemServicio(newPresupuestoItem)
		loadInit(null);
		setItems([]);
		setNewPresupuestoItem({ ...NEW_ITEM_INIT })
	};

	const validate = () => {
		for (let i = 0; i < props.obligatorios.length; i++) {
			if(!newPresupuestoItem[props.obligatorios[i]])
				return true
		}
		return false;
	};

	const handleChangeSelectServicio = (value) => {
		let copy = JSON.parse(JSON.stringify(newPresupuestoItem));
		if(value){
			copy['cantidad'] = value.cantidad ? value.cantidad : '';
			copy['servicio_id'] = value.id;
			copy['servicio'] = value;
		}else{
			copy['cantidad'] = '';
			copy['servicio_id'] = null;
			copy['servicio'] = '';
		}
		setNewPresupuestoItem(copy)
	};

	const handleFormChangeSelectServicio = (value) => {
		let copy = JSON.parse(JSON.stringify(newPresupuestoItem));
		if(value){
			copy.external_code = value.external_code ? value.external_code : ''
			copy.servicio = value
			copy.servicio_id = value.id ? value.id : ''
			copy.nombre = '';
			copy.id_tarea = '';
			copy.precio = '';
			copy.cantidad = '';
			loadItems(value.id);
		}else{
			copy.id = '';
			copy.descripcion = '';
			copy.servicio = null;
			copy.servicio_id = null;
			copy.id_tarea = '';
			copy.precio = '';
			copy.cantidad = '';
			loadInit(null);
		}
		setNewPresupuestoItem(copy)
	};

	const loadServices = (itemId) => {
		if (itemId) {
			Utils.getData('/servicios/simple-search-presupuesto?tipo=item&ticketTipo=' + props.ticket.ticketTipo + '&itemId=' + itemId)
			.then((data) => {
				setServicios(data)
			});
		}else{
			Utils.getData('/servicios/simple-search-presupuesto?tipo=item&ticketTipo=' + props.ticket.ticketTipo)
			.then((data) => {
				setServicios(data)
			});
		}
	}
	
	const loadItems = (servicioId) => {
		Utils.getData('/items/items-de-servicio/' + servicioId + (props.tipoItem ? '?tipoItem=' + encodeURIComponent(props.tipoItem) : ''))
		.then((data) => {
			setItems(data)
		});
	}
	
	const loadInit = (column) => {
		if(props.showItems && props.showItems.length > 0){
			if (ConfigBusiness.get('inventario.marca.obligatorio') === 'false') setMarcaObligatorio(false);

			if (column && busquedaPor === 'descripcion') {
				setLoading(true);
				Utils.getData('/items/simple-search?column=' + column + '&value=' + '' + (props.tipoItem ? '&tipoItem=' + encodeURIComponent(props.tipoItem) : ''))
				.then((data) => {
					setItems(data)
				})
				.finally(() => {
					setLoading(false)
				});
			}else{
				if(props.showItems.includes('id')){
					column = 'id'
				}else if (props.showItems.includes('descripcion')) {
					column = 'descripcion'
				}
				if (column && busquedaPor === 'descripcion') {
					setLoading(true);
					Utils.getData('/items/simple-search?column=' + column + '&value=' + '' + (props.tipoItem ? '&tipoItem=' + encodeURIComponent(props.tipoItem) : ''))
					.then((data) => {
						setItems(data)
					})
					.finally(() => {
						setLoading(false)
					});
				}
			}
			if(busquedaPor === 'servicio'){
				loadServices(null);
			}
		}
		
	}

	const getMarcasByCategoria = (catId) => {
		setLoading(true);
		const comboInsumoMarcaReq = !marcaObligatorio ? Utils.getData(`/panol/insumomarca/select-by-categoria/${catId}`) : null;
		comboInsumoMarcaReq.then(marcas => {
			setComboInsumoMarca(marcas)
		})
		.finally(() => setLoading(false));
	}

	const getClasificaciones = () => {
		setLoading(true);
		Utils.getData(`/item/clasificaciones`)
		.then(response => {
			setClasificaciones(response.clasificaciones || [])
		})
		.catch(error => {
			console.error('Error al cargar clasificaciones:', error);
			setClasificaciones([]);
		})
		.finally(() => setLoading(false));
	}

	return (
		<React.Fragment>
			{redirectTo && <Redirect push to={redirectTo} />}
			{loading && <Loading />}
			<div className="table-responsive" style={{padding: "15px"}}>
				<div style={{marginRight: "3px", marginLeft: "3px", padding: "6px"}}>
					<Grid container item xs={12} spacing={3} style={{marginBottom: props.showItems.includes('detalle') ? 8 : 20}}>
						{props.showItems.filter(function(f) { return f !== 'detalle'; }).map(field => renderField(field))}
						<Grid component={Box} item xs={1}>
							<form noValidate autoComplete="off">
								<button
									className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main"
									style={{ height: 49 }}
									onClick={() => addItem()}
									disabled={validate()}
								>
									<i className="ft-plus"></i>
								</button>
							</form>
						</Grid>
					</Grid>
					{props.showItems.includes('detalle') && (
						<div style={{width: '100%', marginBottom: 20}}>
							<TextField
								id="detalle"
								type="text"
								multiline
								rows={1}
								InputLabelProps={{ shrink: newPresupuestoItem.detalle ? true : undefined }}
								label={intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
								value={newPresupuestoItem.detalle}
								onChange={e => {
									const value = e.target.value;
									if (value.length <= 60) {
										handleMaterialChange('detalle', value);
									}
								}}
								inputProps={{ maxLength: 60 }}
								variant="outlined"
								fullWidth
							/>
							<div style={{textAlign: 'right', fontSize: '0.75rem', color: '#666', marginTop: '2px'}}>
								{newPresupuestoItem.detalle ? newPresupuestoItem.detalle.length : 0}/60
							</div>
						</div>
					)}
				</div>
				<PresupuestoDetalladoItemGrid
					intl={props.intl}
					presupuestoItems={presupuestoItems}
					marcaObligatorio={marcaObligatorio}
					loading={(state) => setLoadingAndUpdate(state)}
					deleteItem={props.deleteItem}
					updateServicioItem={props.updateServicioItem}
					showItems={props.showItems}
					mecanicos={mecanicos}
				/>
				<div className="row p-1" style={{justifyContent: "right"}}>
					<label className="col-md-2 label-control col-form-label" htmlFor="repuestos">
						<FormattedMessage
							id={props.tipoItem === 'Mano de Obra' ? "Presupuesto.Total_Mano_de_Obra" : "Presupuesto.Total_Repuestos"}
							defaultMessage={props.tipoItem === 'Mano de Obra' ? "Total Mano de Obra" : "Total Repuestos"}
						/> {requiredSymbol}:
					</label>
					<div className="col-md-3">
						<div>
							<input disabled
								type="number"
								className="form-control text-right pr-1"
								id="total_repuestos"
								name="total_repuestos"
								value={formatCost(props.totalRepuestos)}
							/>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default injectIntl(PresupuestoDetalladoItem);
